/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { PageMetadata } from './page-metadata';
import { AssegnazioneArticoloCedolaWithChainDTO } from './assegnazione-articolo-cedola-with-chain-dto';


export interface PagedModelAssegnazioneArticoloCedolaWithChainDTO { 
    content?: Array<AssegnazioneArticoloCedolaWithChainDTO>;
    page?: PageMetadata;
}

